import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";

interface CloseButtonProps {
    loading: boolean;
    onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ loading, onClick }) => {
    return (
        <LoadingButton
            loading={loading}
            size="small"
            color="primary"
            variant="outlined"
            onClick={onClick}
        >
            <Localized id="close">_close</Localized>
        </LoadingButton>
    );
};
